import { render, staticRenderFns } from "./GoPortal.vue?vue&type=template&id=6bf88511"
import script from "./GoPortal.vue?vue&type=script&lang=js"
export * from "./GoPortal.vue?vue&type=script&lang=js"
import style0 from "./GoPortal.vue?vue&type=style&index=0&id=6bf88511&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports